export default [
  {
    title: 'Groups',
    icon: 'HomeIcon',
    children: [
      {
        title: 'Bank',
        route: 'group-bank-list',
      },
      {
        title: 'Events',
        route: 'group-event-list',
      },
      {
        title: 'Peoples',
        route: 'group-members-list',
      },
      {
        title: 'Unions',
        route: 'group-union-list',
      },
    ],
  },
]
